import type { NeoArticleCategory, NeoCampaignGroup } from "@expert/types";
import type { MenuLink } from "~~/models/Navigation";

export const mapFromCampaignGroup = (campaignGroup: NeoCampaignGroup) => {
    return {
        name: campaignGroup.title,
        url: `/shop/Aktionen/${campaignGroup.slug}`,
        topLevelMenu: campaignGroup.topLevelMenuItem,
    } as MenuLink;
}

export const mapFromCategory = (category: NeoArticleCategory): MenuLink => {
    return {
        id: category.id,
        name: category.name,
        url: category.slug,
        ancestors: category.parent,
        extId: category.expId,
    }
}